import React from "react";
import { css } from "aphrodite";
import styles from "./sidebar-styles";
import { NavLink } from "react-router-dom";
import { FaAngleDoubleLeft } from "react-icons/fa";
import { FaCaretRight, FaUser } from "react-icons/fa";
import UserMenu from "./user-menu";

const SidebarView = props => (
  <div
    className={css(
      styles.root,
      props.layout.sidebarCollapsed && styles.rootCollapsed
    )}
  >
    <div
      className={css(styles.kiffgoLogoContainer)}
      onClick={props.toggleSidebarCollapse}
    >
      <img
        className={css(
          styles.kiffgoLogoImg,
          props.layout.sidebarCollapsed && styles.kiffgoLogoImgCollapsed
        )}
        src={require("../../assets/kiffgo/logo.svg")}
      />
      <div style={{ flex: 1 }} />
      <FaAngleDoubleLeft
        className={css(
          styles.collapseIcon,
          props.layout.sidebarCollapsed && styles.collapseIconCollapsed
        )}
      />
    </div>

    {props.categories.map((category, index) => (
      <div key={index}>
        {!props.layout.sidebarCollapsed && (
          <div className={css(styles.menuListTitle)}>{category.name}</div>
        )}
        {category.links.map(sidebarItem => (
          <div key={sidebarItem.to}>
            {!sidebarItem.hide &&
              (!sidebarItem.permissionNeeded ||
                props.auth.permissions[sidebarItem.permissionNeeded]) &&
              (!sidebarItem.adminOnly ||
                (!props.auth.business && props.auth.admin)) && (
                <NavLink
                  exact={true}
                  to={sidebarItem.to}
                  className={css(styles.sidebarLink)}
                  activeClassName={css(styles.sidebarLinkActive)}
                  onMouseEnter={() => props.mouseEnterSidebarLink(sidebarItem)}
                  onMouseLeave={props.mouseLeaveSidebarLink}
                >
                  <sidebarItem.icon className={css(styles.icon)} />
                  <div
                    className={css(
                      styles.sidebarTitle,
                      props.layout.sidebarCollapsed &&
                        styles.sidebarTitleCollapsed
                    )}
                  >
                    {sidebarItem.title}
                  </div>

                  {props.layout.sidebarCollapsed && (
                    <div
                      className={css(
                        styles.sidebarTooltip,
                        props.hoveredLink === sidebarItem.title &&
                          styles.sidebarTooltipVisible
                      )}
                    >
                      {sidebarItem.hoverTitle || sidebarItem.title}
                    </div>
                  )}
                </NavLink>
              )}
          </div>
        ))}
      </div>
    ))}

    <div style={{ flex: "0 0 80px" }} />

    <div
      ref={props.setCurrentUserContainerRef}
      className={css(
        styles.currentUserContainer,
        props.layout.sidebarCollapsed && styles.currentUserContainerCollapsed,
        props.userAreaHovered && styles.currentUserContainerHovered
      )}
      onMouseEnter={props.mouseEnterCurrentUser}
      onMouseLeave={props.mouseLeaveCurrentUser}
    >
      <FaUser
        className={css(
          styles.currentUserCog,
          props.layout.sidebarCollapsed &&
            props.userAreaHovered &&
            styles.currentUserCogMove
        )}
      />
      <div
        className={css(
          styles.sidebarTitle,
          props.layout.sidebarCollapsed && styles.sidebarTitleCollapsed,
          styles.currentUserName
        )}
      >
        {props.auth.admin &&
          props.auth.business &&
          props.businessAccounts.byId[props.auth.business_id].name}
        {props.auth.admin && !props.auth.business && "Kiffgo Admin"}
        {!props.auth.admin && props.auth.business_name}
      </div>
      <FaCaretRight
        className={css(
          styles.caretRight,
          props.userAreaHovered && styles.caretRightVisible
        )}
      />

      <div ref={props.setRef}>
        {props.showUserMenu && (
          <div
            className={css(
              styles.userDropUpContainer,
              props.layout.sidebarCollapsed &&
                styles.userDropUpContainerCollapsed
            )}
          >
            <UserMenu />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default SidebarView;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-view.js